exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-8a6268f8] .van-field__body .editInput{background:red;}\n\n", ""]);

// exports
